import { useQuery } from "@tanstack/react-query";
import type { Domain, Role } from "@rrid/shared-types";
import { api } from "../lib/api.js";
import { useAuth } from "../lib/auth.js";

export interface ImpersonationUser {
  email: string;
  name: string;
  roles: Role[];
  domains: Domain[];
  team: string | null;
  lastLoginAt: string | null;
  pilot: boolean;
  cartoon?: boolean;
}

async function fetchImpersonationUsers(): Promise<ImpersonationUser[]> {
  return api.get<ImpersonationUser[]>("/auth/impersonation-users");
}

/** Active users for the Admin impersonation picker (all environments). */
export function useImpersonationUsersList() {
  const { canImpersonate } = useAuth();
  return useQuery({
    queryKey: ["impersonation-users"],
    queryFn: fetchImpersonationUsers,
    enabled: canImpersonate,
    retry: false,
    staleTime: 30_000,
  });
}
